import { createApp } from 'vue';
import App from '@/App.vue';
import router from './router';
import 'deep-chat';

createApp(App).use(router).mount('#app');
